import React from 'react'
import { Link } from 'react-router-dom'

import {arrow} from '../assets/icons';

const HomeInfo = ({currentStage, ...props}) => {
  
    const InfoBox = ({text, link, txtBtn}) => (
        <div className='relative gradient-homeinfo rounded-2xl pt-4 pb-10 px-8 text-white mx-5'>
            <p className='font-medium sm:text-xl text-center'>{text}</p>
            <br />
            <Link to={link} className='absolute bg-white justify-center items-center flex min-w-[90%] py-6 rounded-lg'>
                    <p className='text-sky-600 font-bold tracking-wide '>{txtBtn}</p>
                    <img className='ml-2 object-contain' src={arrow} />

            </Link>
        </div>
    )

    const renderObject =  {
        1: (
            <div className='sm:text-xl sm:leading-snug text-center gradient-hometitle rounded-md py-4 px-8 text-white mx-5'>
                <h1>Hi, I am <span className='font-semibold'>Ahmed 👋</span><br />
                A Software Engineer from Pakistan
                </h1>
            </div>
        ),
        2: (
            <InfoBox text='Worked with many companies and picked many skills along the way' link='/about' txtBtn="Learn more" />
        ),
        3: (
            <InfoBox text='Completed a number of projects over the years. Curious about them?' link='/project' txtBtn="Visit my portfolio" />
            
        ),
        4: (
            <InfoBox text='Need a project or looking for a dev? I am just a few keystrokes away' link='/contact' txtBtn="Let's connect" />
        ),
    }

    

    return renderObject[currentStage] || null;
    
}

export default HomeInfo